export const DeveloperIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
    >
      <g id="hugeicons:developer">
        <g id="Group">
          <path
            id="Vector"
            d="M15.175 22.708V21.699C15.1792 21.4351 15.2869 21.1833 15.4748 20.998C15.6628 20.8126 15.916 20.7085 16.18 20.708H16.255C17.687 20.696 18.917 19.702 19.209 18.32L19.219 18.268L19.739 15.708L20.679 15.244C21.184 14.996 21.435 14.871 21.489 14.644C21.544 14.416 21.375 14.194 21.038 13.749L19.13 11.241C18.94 10.991 18.845 10.867 18.795 10.735C18.745 10.603 18.728 10.415 18.697 10.042C18.353 5.93501 14.865 2.70801 10.612 2.70801C6.132 2.70801 2.5 6.29001 2.5 10.708C2.5 13.458 3.907 15.883 6.05 17.323M6.05 17.323V22.708M6.05 17.323C6.67569 17.746 7.35813 18.0783 8.077 18.31"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_2"
            d="M14 9.70801L14.92 10.501C15.307 10.834 15.5 11.001 15.5 11.208C15.5 11.415 15.307 11.582 14.92 11.915L14 12.708M7 9.70801L6.08 10.501C5.693 10.834 5.5 11.001 5.5 11.208C5.5 11.415 5.693 11.582 6.08 11.915L7 12.708M11.5 8.70801L9.5 13.708"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </svg>
  );
};
